'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OVERENI_ID_NONE = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lib = require('mc/lib');

var _reactstrap = require('reactstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Id ověření v případě, že uživatel stiskl ověřit a z registrů se nic nedohledalo - je neztotožněn
var OVERENI_ID_NONE = exports.OVERENI_ID_NONE = -23675;

/**
 * Komponenta pro zobrazení informace o dohledání (ověření) subjektu vůči registrům.
 */
// --

var SubjektOvereniInfo = function (_React$Component) {
    (0, _inherits3.default)(SubjektOvereniInfo, _React$Component);

    function SubjektOvereniInfo() {
        (0, _classCallCheck3.default)(this, SubjektOvereniInfo);
        return (0, _possibleConstructorReturn3.default)(this, (SubjektOvereniInfo.__proto__ || (0, _getPrototypeOf2.default)(SubjektOvereniInfo)).apply(this, arguments));
    }

    (0, _createClass3.default)(SubjektOvereniInfo, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                vazbaZr = _props.vazbaZr,
                subjekt = _props.subjekt,
                roleConf = _props.roleConf,
                overeniIdInt = _props.overeniIdInt;


            var overeniInfo = [];
            var color = void 0;
            if (vazbaZr || roleConf.ares) {
                if (overeniIdInt != null) {
                    if (overeniIdInt === OVERENI_ID_NONE) {
                        // pokus o dohledání, ale nebyl dohledán - je neztotožněn
                        color = "warning";
                        overeniInfo.push(_react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_lib.Icon, { icon: 'exclamation-triangle' }),
                            ' ',
                            roleConf.ares ? "Neztotožněn" : "Neztotožněn vůči základním registrům"
                        ));
                    } else {
                        color = "success";
                        overeniInfo.push(_react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_lib.Icon, { icon: 'check' }),
                            ' ',
                            roleConf.zr ? "Ověřen v základních registrech" : "Dohledán v ARES"
                        ));
                    }
                } else {
                    color = "danger";
                    if (roleConf.zr) {
                        overeniInfo.push(_react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_lib.Icon, { icon: 'remove' }),
                            ' Neov\u011B\u0159en v z\xE1kladn\xEDch registrech'
                        ));
                    }
                }
            } else {
                color = "info";
                if (roleConf.zr) {
                    overeniInfo.push(_react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_lib.Icon, { icon: 'chain' }),
                        ' Bez vazby na z\xE1kladn\xED registry'
                    ));
                }
            }

            if (overeniInfo.length > 0) {
                return _react2.default.createElement(
                    _reactstrap.Alert,
                    { className: className, color: color },
                    overeniInfo
                );
            } else {
                return _react2.default.createElement('span', null);
            }
        }
    }]);
    return SubjektOvereniInfo;
}(_react2.default.Component);

SubjektOvereniInfo.PropTypes = {
    subjekt: _react2.default.PropTypes.object.isRequired // subjekt
};
exports.default = SubjektOvereniInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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